import sortBy from 'lodash/sortBy'
import { createAsyncThunk, createSelector } from '@reduxjs/toolkit'
import { ListNavigationItemsResponse } from '../../types/swagger'
import api from '../../utils/api'
import createRequestSlice from '../../utils/createRequestSlice'
import { RootState } from '../../store'
import { NavItem } from '../../types'

export const fetchNavigation = createAsyncThunk(
    'GET_NAVIGATIONS',
    async ({ eventSlug }: { eventSlug: string }) => api.get<ListNavigationItemsResponse>(`/events/${eventSlug}/navigation/`),
)

const navigationSlice = createRequestSlice<ListNavigationItemsResponse>(fetchNavigation, 'fetchNavigation')
export const { emptyData } = navigationSlice.actions
export default navigationSlice.reducer

export const navSelector = createSelector(
    [(state: RootState) => state.event.navigation],
    (navigation) => {
        if (navigation.status !== 'succeeded') {
            return []
        }

        const categories: Record<number, NavItem> = {}
        const firstLevelItems: NavItem[] = []
        navigation.data.results.forEach((item) => {
            const { category } = item
            if (category) {
                categories[category.id] = categories[category.id] || { ...category, children: [] }
                categories[category.id].children.push(item)
            } else {
                firstLevelItems.push(item)
            }
        })

        const sortedCategories = Object.values(categories).map((category) => ({
            ...category,
            children: sortBy(category.children, 'order'),
        }))

        return sortBy([
            ...sortedCategories,
            ...firstLevelItems,
        ], 'order')
    },
)
